import { StringValidacao } from './string';
import { Construtor } from './construtor';

export class CriticidadeRotina implements Construtor<CriticidadeRotina> {

    public idCriticidadeRotina: number;
    public descricaoCriticidade: string;
    public selecionado: boolean;

    constructor(object?: any) {

        if (object !== undefined) {

            if (object instanceof CriticidadeRotina) {
                this.copyObject(object);
            } else {
                this.parseFromJson(object);
            }

            return this.modeloCompleto() ? this : null;
        }

        return this;
    }

    get obterIdCriticidadeRotina(): number {
        return this.idCriticidadeRotina;
    }

    set IdCriticidadeRotina(id: any) {
        this.idCriticidadeRotina = id;
    }

    get obterDescricaoCriticidade(): string {
        return this.descricaoCriticidade.slice(0);
    }

    set DescricaoCriticidade(descricaoCriticidade: any) {
        this.descricaoCriticidade = StringValidacao.copiarStringValida(descricaoCriticidade);
    }

    copyObject(criticidade: CriticidadeRotina): void {

        this.idCriticidadeRotina = criticidade.obterIdCriticidadeRotina;
        this.descricaoCriticidade = criticidade.obterDescricaoCriticidade;
    }

    parseFromJson(criticidade: any): void {

        this.IdCriticidadeRotina = criticidade.idCriticidadeRotina;
        this.DescricaoCriticidade = criticidade.descricaoCriticidade;

    }

    modeloCompleto(): boolean {
        return this.descricaoCriticidade !== undefined;
    }

    getNewInstance(object?: any): CriticidadeRotina {
        return new CriticidadeRotina(object);
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/criticidade-rotina.ts